import { render } from "./ActionCard.vue?vue&type=template&id=6a0ace01&scoped=true"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"

import "./ActionCard.vue?vue&type=style&index=0&id=6a0ace01&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0ace01"]])

export default __exports__